import { Phone, MessageCircle } from "lucide-react";
import { telLink, waLink } from "@/config/business";
import { Reveal } from "@/components/Reveal";

export default function FinalCta() {
  return (
    <section className="relative bg-deep py-24 md:py-36 overflow-hidden" data-testid="final-cta-section">
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none font-display text-[26vw] leading-none text-cream whitespace-nowrap select-none"
        aria-hidden="true"
      >
        Lavniya
      </div>
      <div className="relative max-w-4xl mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <h2 className="font-display text-4xl sm:text-5xl md:text-6xl tracking-tight text-cream">
            Ready for Your Next Appointment?
          </h2>
          <p className="mt-6 text-base sm:text-lg leading-relaxed text-cream/70 max-w-2xl mx-auto">
            Choose your service, give us a call or send a WhatsApp message. We're here to
            help you plan your next beauty or grooming visit.
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <a
              data-testid="final-call-button"
              href={telLink}
              className="inline-flex items-center gap-2 bg-cream text-deep px-8 py-4 text-sm font-semibold uppercase tracking-widest hover:bg-accent hover:text-deep transition-colors min-h-[48px]"
            >
              <Phone size={16} /> Call Now
            </a>
            <a
              data-testid="final-whatsapp-button"
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-wa text-white px-8 py-4 text-sm font-semibold uppercase tracking-widest hover:opacity-90 transition-opacity min-h-[48px]"
            >
              <MessageCircle size={16} /> WhatsApp Us
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
